import Vue from 'vue'
import Vuex from 'vuex'

import sharedStore from './modules/shared';
import menuStore from './modules/menu';
import homeStore from './modules/home';
import photosStore from './modules/photos';
import postsStore from './modules/posts';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    // strict: true,  // process.env.NODE_ENV !== 'production',
    strict: debug,
    // actions,
    // getters,
    modules: {
        sharedStore,
        menuStore,
        homeStore,
        photosStore,
        postsStore,
    },
    state: {

    },
    mutations: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js